import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PlaybackPolicy } from '@shared/interfaces/assistantScript';
import ChoiceCard from '../ChoiceCard';
import { PlaybackSection } from './styled';
import { PlaybackPolicySectionProps } from './interfaces';
import { POLICIES } from './constants';

const PlaybackPolicySection = ({
  triggerType,
  playbackPolicy,
  onPlaybackPolicyChange,
  skipFirstSession,
  onSkipFirstSessionChange,
}: PlaybackPolicySectionProps) => {
  void skipFirstSession;
  void onSkipFirstSessionChange;

  const { t } = useTranslation('common');

  // ui_click scripts are always started explicitly by the user clicking the
  // button, so "how often" only ever means "every time" — show that single
  // option instead of the full session/experience-based policy list.
  const visiblePolicies =
    triggerType === 'ui_click'
      ? POLICIES.filter((p) => p.id === PlaybackPolicy.ALWAYS)
      : POLICIES;

  return (
    <PlaybackSection>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
        {visiblePolicies.map((p) => (
          <ChoiceCard
            key={p.id}
            icon={p.icon}
            title={t(`assistant.scriptDialog.policies.${p.id}.name`)}
            desc={
              triggerType === 'ui_click' && p.id === PlaybackPolicy.ALWAYS
                ? t('assistant.scriptDialog.wizard.policyAlwaysUiClickDesc')
                : t(`assistant.scriptDialog.policies.${p.id}.desc`)
            }
            badge={
              p.badge && t(`assistant.scriptDialog.policies.${p.id}.badge`)
            }
            selected={playbackPolicy === p.id}
            onClick={() => onPlaybackPolicyChange(p.id)}
            dataTestId={`assistant-script-policy-option-${p.id}`}
          />
        ))}
      </Box>
    </PlaybackSection>
  );
};

export default PlaybackPolicySection;
